import React, { memo, useMemo } from 'react';

import EntityFormModal from '@sharedCR/common/EntityFormModal';
import PropTypes from 'prop-types';

import PaymentDrawerContent from './PaymentDrawerContent';

const PaymentDrawer = ({ isOpen, onClose, payment, paymentSchedule, applicationId, onSuccess }) => {
  const title = payment ? 'Edit Payment' : 'Record Payment';

  const additionalProps = useMemo(
    () => ({ payment, paymentSchedule, applicationId, onSuccess }),
    [payment, paymentSchedule, applicationId, onSuccess],
  );

  return (
    <EntityFormModal
      isData
      isHiddenNavigationTabs
      Content={PaymentDrawerContent}
      additionalProps={additionalProps}
      isOpen={isOpen}
      title={title}
      onClose={onClose}
    />
  );
};

PaymentDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  applicationId: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
  payment: PropTypes.object,
  paymentSchedule: PropTypes.array,
};

export default memo(PaymentDrawer);
